import {groq} from 'next-sanity';

export const allPostsQuery = groq`*[_type == "post" && publishedAt < now()] | order(publishedAt desc) {title, "authors": author[]->name, description, mainImage, publishedAt, "tags": tags[]->title, slug}`;

export const allPostsAndDraftsDraftsQuery = groq`*[_type == "post"] | order(publishedAt desc) {title, "authors": author[]->name, description, mainImage, publishedAt, "tags": tags[]->title, slug, _id}`;

// done

export const tagQuery = groq`
      *[_type == "tag" && lower(title) == $slug][0]{title, "posts": *[_type == "post" && references(^._id
  ) ] | order(publishedAt desc) { title, description, mainImage, publishedAt, "authors": author[]->name,  "tags": tags[]->title, "slug": slug.current}}
    `;

export const tagQueryAsTitleOnly = groq`
  *[_type == "tag" && defined(title)][] {title}
  `;

export const authorQuery = groq`
      *[_type == "author" && slug.current == $slug][0]{name, slug, "posts": *[_type == "post" && references(^._id
  ) ] | order(publishedAt desc) { title, description, mainImage, publishedAt, "tags": tags[]->title, "slug": slug.current}}
    `;

export const authorQueryAsSlugOnly = groq`
  *[_type == "author" && defined(slug.current)][] {"slug": slug.current}
  `;

export const singlePostQueryAsSlugOnly = groq`
  *[_type == "post" && defined(slug.current)][] {"slug": slug.current, publishedAt}
  `;

export const singlePostQuery = groq`
    *[_type == "post" && slug.current == $slugWithoutDates][0] {title, "authorLinks": author[]->slug, "authors": author[]->name, mainImage, description, publishedAt, "tags": tags[]->title, slug, body}
  `;
